import store from '@store'
import { storeOptions } from "./ipetbooking-options";

export function storeFilter() {
  const storeStore = storeOptions({
    type: 'open'
  });

  return storeStore.map(item => {
    return {
      id: item.alias,
      label: item.title
    }
  })
}

export function categoryFilter() {
  const storePetCategories = store.state.merchant.currentMerchant?.petCategories || [];

  storePetCategories.filter(item => {
    return item.children
  });

  return storePetCategories.map(item => {
    const children = (data) => {
      return data.children
        ? data.children.map(childrenItem => {
          return {
            id: childrenItem.alias,
            label: childrenItem.title,
            children: children(childrenItem)
          }
        })
        : []
    };

    return {
      id: item.alias,
      label: item.title,
      children: children(item)
    }
  })
}
